export type StrengthFreshness = {
  strengthScore: number | null;
  freshnessDays: number | null;
  freshnessBand: 'Unranked' | 'Fresh' | 'Active' | 'Aging' | 'Stale' | 'Unknown';
  lastVerifiedLiftAt: string | null;
};

const mapBand = (
  raw: string | null | undefined,
  lastVerifiedLiftAt: string | null
): StrengthFreshness['freshnessBand'] => {
  const band = String(raw ?? '').trim();
  if (band === 'Unranked') return 'Unranked';
  if (band === 'Fresh') return 'Fresh';
  if (band === 'Active') return 'Active';
  if (band === 'Aging') return 'Aging';
  if (band === 'Stale') return 'Stale';
  if (!lastVerifiedLiftAt) return 'Unranked';
  return 'Unknown';
};

export async function fetchStrengthFreshness(
  supabaseClient: { rpc: (fn: string, params: Record<string, unknown>) => PromiseLike<{ data: unknown; error: unknown }> },
  handle: string
): Promise<StrengthFreshness> {
  if (!handle) {
    return {
      strengthScore: null,
      freshnessDays: null,
      freshnessBand: 'Unknown',
      lastVerifiedLiftAt: null,
    };
  }

  try {
    const { data, error } = await supabaseClient.rpc('rpc_strength_freshness_v1', {
      p_handle: handle,
    });

    if (error) {
      return {
        strengthScore: null,
        freshnessDays: null,
        freshnessBand: 'Unknown',
        lastVerifiedLiftAt: null,
      };
    }

    const row = Array.isArray(data) ? data[0] : data;
    const strengthScore =
      typeof row?.strength_score === 'number' ? row.strength_score : null;
    const freshnessDays =
      typeof row?.freshness_days === 'number' ? row.freshness_days : null;
    const lastVerifiedLiftAt = row?.last_verified_lift_at ?? null;
    const freshnessBand = mapBand(row?.freshness_band, lastVerifiedLiftAt);

    return {
      strengthScore,
      freshnessDays,
      freshnessBand,
      lastVerifiedLiftAt,
    };
  } catch {
    return {
      strengthScore: null,
      freshnessDays: null,
      freshnessBand: 'Unknown',
      lastVerifiedLiftAt: null,
    };
  }
}
